import { SECTION_HERO_XML } from '../../../shared/onboardingSectionArt.js'
import { Link } from 'react-router-dom'
import Seo from '../components/Seo'
import MarketingNav from '../components/MarketingNav'
import MarketingFooter from '../components/MarketingFooter'
import PageHero from '../components/ds/PageHero'
import Section from '../components/ds/Section'

// The hub for the contracts and policies. Linked from the footer, from both
// apps' settings, and from the sign up consent lines.

const DOCS = [
  { slug: 'terms',           title: 'Terms of Business',     sub: 'The contract between a workplace and TempDash' },
  { slug: 'privacy',         title: 'Privacy Policy',        sub: 'How we collect, use and protect your data under UK GDPR' },
  { slug: 'worker-privacy',  title: 'Worker Privacy Policy', sub: 'For people working shifts through the app, including calendar sync' },
  { slug: 'cookies',         title: 'Cookie Notice',         sub: 'The cookies and storage we use, and how to manage them' },
]

function Row({ href, to, title, sub }) {
  const inner = (
    <>
      <span>
        <span className="block text-[19px] font-semibold text-ink">{title}</span>
        <span className="mt-1 block text-[16px] text-ink-muted">{sub}</span>
      </span>
      <span aria-hidden="true" className="mt-1 shrink-0 text-ink-muted">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6" /></svg>
      </span>
    </>
  )
  const cls = 'flex items-start justify-between gap-6 rounded-card border border-hairline bg-surface p-6 shadow-[0_4px_10px_rgba(12,24,41,0.04)] transition-colors hover:border-ink/25'
  return <li>{to ? <Link to={to} className={cls}>{inner}</Link> : <a href={href} className={cls}>{inner}</a>}</li>
}

export default function LegalIndex() {
  return (
    <div className="bg-canvas">
      <Seo
        title="Legal and policies"
        description="The contracts and policies that govern your use of TempDash: terms of business, privacy, worker privacy and our cookie notice."
        path="/legal"
      />
      <MarketingNav />

      {/* ⚠️ The ONE main landmark. Without it every <section> on the page
          sits outside any landmark and a screen reader user navigating by
          landmark cannot reach the content at all. The skip link in
          MarketingNav targets this id. */}
      <main id="main" tabIndex={-1} className="outline-none">

      <PageHero
        art={SECTION_HERO_XML.signing}
        width="text"
        title="Legal and policies"
        lead="The contracts and policies that govern your use of TempDash. We tell you in the app whenever one of them changes."
      />

      <Section ground="canvas" width="text">
        <ul className="space-y-3">
          {DOCS.map((d) => <Row key={d.slug} to={`/legal/${d.slug}`} title={d.title} sub={d.sub} />)}
          {/* Plain <a>, NOT <Link>: /legal/referral-terms is reverse-proxied to
              the API, because the document quotes admin editable numbers and is
              rendered live rather than bundled. A client side <Link> would keep
              the SPA mounted and never reach the proxy. */}
          <Row
            href="/legal/referral-terms"
            title="Refer a friend: promotion terms"
            sub="Eligibility, the time limit, and how the reward works"
          />
        </ul>
      </Section>

      </main>

      <MarketingFooter />
    </div>
  )
}
